import { ApiUrl, ApiUrlAdmin } from "./common/Config";
import { postAdmin,post,get,getAdmin,postFormData } from "./common/Helper";



export const fetchTopicStatsReport = async (payload,token) => {
    // It is common to pass token, but since prompt didn't specify, we use null
    let url = ApiUrl + 'analytics/gettopicstats/report'
    return await post(url,payload,token)
  };
  
  export const fetchQuestionCountReport = async (payload,token) => {
    let url = ApiUrl + 'analytics/getquestioncount/report'
    return await post(url,payload,token)
  };
